import { render, staticRenderFns } from "./Flashlight.vue?vue&type=template&id=c1849616&scoped=true&"
import script from "./Flashlight.vue?vue&type=script&lang=js&"
export * from "./Flashlight.vue?vue&type=script&lang=js&"
import style0 from "./Flashlight.vue?vue&type=style&index=0&id=c1849616&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1849616",
  null
  
)

export default component.exports